import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import CXQueueContainer from './CXQueue';

export const CXQueueModule = () => (
  <Route exact path={APP_ROUTES.CX_QUEUE_MODULE.PATH} component={CXQueueContainer} />
);
